import { Box, Heading, Icon, Image, List, MediaObject, Paragraph, Popover } from '@zillow/constellation-10';
import { IconEditOutline, IconHandshakeOutline, IconMessageHeartOutline } from '@zillow/constellation-icons';
import CalendarClock from '../../../../../images/calenderClock.svg';
import { useLeaseQuery } from '../../../utils/queries';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

export default function WhatToDoWhenALeaseIsEnding() {
  const { leaseId } = useLeasingUrlParams();
  const leaseQuery = useLeaseQuery(leaseId);

  return (
    <>
      <Box css={{ marginBottom: 'loose' }}>
        <Image
          src={CalendarClock}
          alt="calendar with a clock icon on the bottom right"
          css={{ height: '160px', width: '160px' }}
        />
      </Box>
      <Heading level={2} css={{ textStyle: 'responsive.heading-md', marginBottom: 'looser' }}>
        What to do when a lease is ending
      </Heading>
      <List.Root appearance="none">
        <List.Item>
          <MediaObject
            media={
              <Icon size="lg" role="img">
                <IconMessageHeartOutline />
              </Icon>
            }
            css={{ marginBottom: 'looser' }}
          >
            <Heading level={3} css={{ textStyle: 'responsive.body-lg-bold' }}>
              {leaseQuery?.data?.tenants?.length > 1 ? (
                <>
                  Tell your tenants your plans{' '}
                  <Popover
                    header={<Heading level={4}>Notify your renters</Heading>}
                    body={
                      <Paragraph>
                        Local regulations may require you to notify all renters on your lease about their renewal
                        options by a certain time.
                      </Paragraph>
                    }
                  />
                </>
              ) : (
                <>
                  Tell your tenant your plans{' '}
                  <Popover
                    header={<Heading level={4}>Notify your renters</Heading>}
                    body={
                      <Paragraph>
                        Local regulations may require you to notify all renters on your lease about their renewal
                        options by a certain time.
                      </Paragraph>
                    }
                  />
                </>
              )}
            </Heading>
            <Paragraph css={{ color: 'text.medium' }}>And find out what theirs are too.</Paragraph>
          </MediaObject>
        </List.Item>
        <List.Item>
          <MediaObject
            media={
              <Icon size="lg" role="img">
                <IconHandshakeOutline />
              </Icon>
            }
            css={{ marginBottom: 'looser' }}
          >
            <Heading level={3} css={{ textStyle: 'responsive.body-lg-bold' }}>
              Decide what to do with your lease
            </Heading>
            <Paragraph css={{ color: 'text.medium' }}>
              We’ll walk you through your options depending on what you want to do.
            </Paragraph>
          </MediaObject>
        </List.Item>
        <List.Item>
          <MediaObject
            media={
              <Icon size="lg" role="img">
                <IconEditOutline />
              </Icon>
            }
            css={{ marginBottom: 'looser' }}
          >
            <Heading level={3} css={{ textStyle: 'responsive.body-lg-bold' }}>
              Get ahead on important tasks
            </Heading>
            <Paragraph css={{ color: 'text.medium' }}>
              Whether that’s getting your next lease signed or preparing to relist.
            </Paragraph>
          </MediaObject>
        </List.Item>
      </List.Root>
    </>
  );
}
